import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ShopService } from '@app/services/shops/shop.service';
import { filter, map, take } from 'rxjs';

export const maxxSettingsGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(ShopService).shop$.pipe(
    filter((shop) => !!shop),
    take(1),
    map((shop) =>
      String(shop.metadata?.maxx_external_agent_enabled) === 'true' ? true : router.parseUrl('/settings'),
    ),
  );
};
